window.matchMedia("(max-width: 989px").addListener((x) => {
  if (x.matches) { // If media query matches
    document.querySelector(".ctm-account__banner").style.display = "none";
    document.querySelector(".ctm-account__menu-wrapper").style.display = "none"
  } else {
    document.querySelector(".ctm-account__banner").style.display = "block";
    document.querySelector(".ctm-account__menu-wrapper").style.display = "block"
  }
})

if (document.querySelector(".button-back")) {
  document.querySelector(".button-back").addEventListener("click", () => {
    document.querySelector(".ctm-account__banner").style.display = "block";
    document.querySelector(".ctm-account__menu-wrapper").style.display = "block";
    document.querySelector(".ctm-account__content").style.display = "none";
    document.querySelector(".button-back").classList.add("ctm-hide")
  })
}

// Load more
const loadMore = document.querySelector(".order-detail__load-more");

let currentItems = 3;
  if (loadMore) {
  loadMore.addEventListener('click', (e) => {
    e.preventDefault();
    const elementList = [...document.querySelectorAll('tbody tr')];
    for (let i = currentItems; i < currentItems + 3; i++) {
      if (elementList[i]) {
        elementList[i].style.display = 'table-row'
      }
    }
    currentItems += 3;

    if (currentItems >= elementList.length) {
      loadMore.classList.add('loaded')
    }
  })
}